import { CooperationPartnerId } from '@app/icare/entities/cooperationPartner/schema/CooperationPartner'

import { entityId } from '@pkg/db/schema'
import type { z } from 'zod'

import { PatientRelation } from './PatientRelation'

export const PatientCooperationPartnerId = entityId('patientCooperationPartner')

export type PatientCooperationPartnerIdType = typeof PatientCooperationPartnerId.Type

export const PatientCooperationPartnerRelationSchema = PatientRelation.extend({
  id: PatientCooperationPartnerId.schema,
  toId: CooperationPartnerId.ref,
})

export type PatientCooperationPartnerRelation = z.infer<typeof PatientCooperationPartnerRelationSchema>
